import React from 'react'
import styled from 'styled-components'
import { ToggleSwitch } from 'examkrackers-components'

const TOGGLE_ORANGE = '#F8961A'
const LABEL_COLOR = '#444444'

type AllRedDotsToggleProps = {
  isVisible: boolean
  disabled?: boolean
  titleLabel: string
  hideLabel: string
  showLabel: string
  ariaLabel: string
  onToggle: () => void
  switchId?: string
}

const AllRedDotsToggle = ({
  isVisible,
  disabled = false,
  titleLabel,
  hideLabel,
  showLabel,
  ariaLabel,
  onToggle,
  switchId = 'all-red-dots'
}: AllRedDotsToggleProps): JSX.Element => {
  const labelId = `${switchId}-label`

  const handleChange = () => {
    if (disabled) {
      return
    }
    onToggle()
  }

  return (
    <ToggleContainer>
      <TitleLabel id={labelId}>{titleLabel}</TitleLabel>
      <ToggleRow>
        <SideLabel>{hideLabel}</SideLabel>
        <SwitchWrap aria-labelledby={labelId}>
          <ToggleSwitch
            name={switchId}
            id={switchId}
            checked={isVisible}
            value={isVisible}
            disabled={disabled}
            onChange={handleChange}
            aria-label={ariaLabel}
          />
        </SwitchWrap>
        <SideLabel>{showLabel}</SideLabel>
      </ToggleRow>
    </ToggleContainer>
  )
}

export default AllRedDotsToggle

const ToggleContainer = styled.div`
  display: inline-flex;
  flex-direction: column;
  align-items: center;
`

const TitleLabel = styled.span`
  font-family: Arial, sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 14px;
  color: ${LABEL_COLOR};
  text-align: center;
  white-space: pre-line;
`

const ToggleRow = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 32px;
  min-height: 32px;
`

const SideLabel = styled.span`
  font-family: Arial, sans-serif;
  font-size: 10px;
  font-weight: 400;
  line-height: 1;
  color: ${LABEL_COLOR};
  text-transform: uppercase;
`

const SwitchWrap = styled.div`
  display: inline-flex;
  align-items: center;
  line-height: 0;

  label {
    width: 28px !important;
    height: 16px !important;
  }

  label > span {
    border-radius: 16px !important;
  }

  input:checked + span {
    background-color: ${TOGGLE_ORANGE} !important;
    border-color: ${TOGGLE_ORANGE} !important;
  }

  label > span::before {
    width: 12px !important;
    height: 12px !important;
    left: 2px !important;
    bottom: 1px !important;
  }

  input:checked + span::before {
    transform: translateX(12px) !important;
  }
`
